export default __webpack_public_path__ + "static/media/LabReceive.48dd2967.svg";